(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('.hero-slideshow');

  sections.forEach(function (section) {
    const slides    = section.querySelectorAll('.hero-slideshow__slide');
    const dots      = section.querySelectorAll('.hero-slideshow__dot');
    const prevBtn   = section.querySelector('.hero-slideshow__arrow--prev');
    const nextBtn   = section.querySelector('.hero-slideshow__arrow--next');
    const autoplay  = section.dataset.autoplay === 'true';
    const speed     = parseInt(section.dataset.autoplaySpeed, 10) || 5000;
    const isFade    = section.dataset.transition === 'fade';

    let current  = 0;
    let timer    = null;
    let leaving  = false;

    function goTo(index) {
      if (leaving) return;
      const prev = current;
      current = (index + slides.length) % slides.length;
      if (current === prev) return;

      leaving = true;

      // Remove active from current slide
      slides[prev].classList.remove('is-active');
      slides[prev].setAttribute('aria-hidden', 'true');

      if (!isFade) {
        // Slide transition: tag the leaving slide
        slides[prev].classList.add('is-leaving');
      }

      // Activate next slide
      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');

      // Update dots
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
        d.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });

      // Clean up after transition
      const dur = isFade ? 700 : 700;
      setTimeout(function () {
        if (!isFade) slides[prev].classList.remove('is-leaving');
        leaving = false;
      }, dur);
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (!autoplay || slides.length < 2) return;
      clearInterval(timer);
      timer = setInterval(next, speed);
    }

    function stopAutoplay() { clearInterval(timer); }

    // Arrow controls
    if (prevBtn) prevBtn.addEventListener('click', function () { stopAutoplay(); prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stopAutoplay(); next(); startAutoplay(); });

    // Dot controls
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stopAutoplay();
        goTo(parseInt(dot.dataset.index, 10));
        startAutoplay();
      });
    });

    // Keyboard navigation
    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { stopAutoplay(); prev(); startAutoplay(); }
      if (e.key === 'ArrowRight') { stopAutoplay(); next(); startAutoplay(); }
    });

    // Touch/swipe support
    let touchStartX = 0;
    section.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    section.addEventListener('touchend', function (e) {
      const diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) {
        stopAutoplay();
        diff > 0 ? next() : prev();
        startAutoplay();
      }
    }, { passive: true });

    // Pause on hover
    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
